export enum DocumentStatusExecutionStatus {
    NA,
    Provided,
    Executed,
    Offered,
}

export const DocumentStatusExecutionStatusOptions = {
    [DocumentStatusExecutionStatus.NA]: '',
    [DocumentStatusExecutionStatus.Provided]: 'Provided',
    [DocumentStatusExecutionStatus.Executed]: 'Executed',
    [DocumentStatusExecutionStatus.Offered]: 'Offered',
};
